import {
  getActivityFrequencyLabel,
  getAgeGroupLabel,
  getActivityStyleLabel
} from './recruitmentLabels';

const DIFFICULTY_LABELS = Object.freeze({
  beginner: '初級者向け',
  intermediate: '中級者向け',
  advanced: '上級者向け'
});

const RECRUITMENT_STATUS_LABELS = Object.freeze({
  active: '募集中',
  closed: '募集終了',
  cancelled: '中止'
});

export {
  getActivityFrequencyLabel,
  getAgeGroupLabel,
  getActivityStyleLabel
};

export function getDifficultyLabel(value) {
  if (!value) return '';
  return DIFFICULTY_LABELS[value] || value;
}

export function getRecruitmentStatusLabel(value) {
  if (!value) return '';
  return RECRUITMENT_STATUS_LABELS[value] || value;
}
